import React from 'react';
import OperadorParametrosFaixaBancariaService from '../../../../lib/api/operadorParametrosFaixaBancaria/operadorParametrosFaixaBancariaService';
import TemplateParametro from '../shared/templateParametros/templateParametros';

class OperadorParametrosFaixaBancaria extends React.Component<{},{}>
{
    constructor(props: any) 
    {
        super(props);
        this.state = {};
    }

    baixarExcelOperadorParametrosFaixaBancaria()
    {
        return OperadorParametrosFaixaBancariaService.obterExcel()
    }

    enviarParametrosEventGrid() 
    {
        return OperadorParametrosFaixaBancariaService.enviarParametrosAoEventGrid();
    }

    render() 
    {
        return (
            <TemplateParametro
                enviarParametrosEventGrid={this.enviarParametrosEventGrid}
                baixarExcelParametros={this.baixarExcelOperadorParametrosFaixaBancaria}
                enviarExcelParametros={OperadorParametrosFaixaBancariaService.enviarExcelParametros}
                deletarExcelParametros = {OperadorParametrosFaixaBancariaService.deletarExcelParametros}
                nomeDoArquivo='Operador Parametros Faixa Bancaria'
            ></TemplateParametro>
        );
    }
}

export default OperadorParametrosFaixaBancaria